import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ThumbSourceFactoryService } from '../../../../shared/services/thumb-source-factory.service';

@Component({
    selector: 'account-orders-details-items',
    templateUrl: './account.orders.details.items.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsItemsComponent {
    @Input('items') items: Array<any>;
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/account/orders/details/items/account.orders.details.items.component.ts